import React from "react";
import PropTypes from "prop-types";


export const ClientSurveyIcon = (props) => {

    return (
        <>
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='20'
                height='21'
                fill='none'
                stroke={props.selectedIcon ? "#448BCA" : "#6B778C"}
                data-my-extension-installed='true'
                viewBox='0 0 20 21'
                {...props}
            >
                <path
                    fill={props.selectedIcon ? "#448BCA" : "#6B778C"}
                    stroke={props.selectedIcon ? "#448BCA" : "#6B778C"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                    d='m9.89 10.947.09.003.029-.01.018.001q.022 0 .045.004l.038.003.038-.002a2.86 2.86 0 0 0 2.706-2.849v-.003a2.856 2.856 0 0 0-2.853-2.854 2.856 2.856 0 0 0-2.854 2.854 2.844 2.844 0 0 0 2.742 2.853Zm.222.395h-.1500000000000001c-1.842-.06-3.201-1.488-3.201-3.24a3.256 3.256 0 0 1 3.249-3.248 3.256 3.256 0 0 1 3.249 3.248 3.234 3.234 0 0 1-3.127 3.24h-.01900000000000001ZM3.594 17.427l-.005-.005a.2.2 0 0 1-.058-.165c.104-.925.685-1.835 1.733-2.533 1.287-.856 3.002-1.298 4.74-1.298s3.45.442 4.732 1.297c1.053.711 1.634 1.615 1.735 2.541l.001.008a.17.17 0 0 1-.06.15l-.005.005a9.46 9.46 0 0 1-6.406 2.492 9.46 9.46 0 0 1-6.407-2.492Zm.42-.545-.093.315.252.21A9.07 9.07 0 0 0 10 19.524a9.07 9.07 0 0 0 5.828-2.117l.251-.21-.093-.315c-.21-.711-.75-1.346-1.474-1.835l-.002-.002c-1.246-.83-2.891-1.228-4.508-1.228s-3.266.398-4.52 1.227l-.004.003c-.727.492-1.256 1.127-1.465 1.835Z'
                ></path>
                <path
                    fill={props.selectedIcon ? "#448BCA" : "#6B778C"}
                    stroke={props.selectedIcon ? "#448BCA" : "#6B778C"}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1"
                    d='M10 19.92c-5.24 0-9.5-4.26-9.5-9.5S4.76.92 10 .92s9.5 4.259 9.5 9.5-4.26 9.5-9.5 9.5Zm0-18.605c-5.02 0-9.105 4.084-9.105 9.104S4.98 19.524 10 19.524s9.105-4.085 9.105-9.105S15.02 1.315 10 1.315Z'
                ></path>
            </svg>
        </>

    )
}

ClientSurveyIcon.propTypes = {
    selectedIcon: PropTypes.bool,
};